import React from "react";

import { DatePicker } from "antd";

const CustomDatePicker = ({ value, children, disabled = false, style = {}, ...props }) => {
  return (
    <DatePicker
      disabled={disabled}
      value={value}
      style={{
        width: "100%",
        border: "0px",
        backgroundColor: "transparent",
        borderBottom: "1px solid #9B9B9B",
        ...style
      }}
      {...props}
    >
      {children}
    </DatePicker>
  );
};

export { CustomDatePicker };
